<template>
	<v-dialog v-model="newLabelDialog" width="600px">
    <customDialog>
      <template v-slot:title>
        {{t('newLabel')}}
        <button id="dialog_exit" @click="newLabelDialog = false">
          <img src="@/assets/images/popup_close.png" id="btn_img">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pt-7 pb-10 dialog_text" align="center">
              <v-col class="ma-0 pa-0 pb-2" cols="auto">
                {{t('inputLabelName')}}
              </v-col>
              <v-col class="ma-0 pa-0 pl-3" cols="12">
                <input type="text" class="change_name_input" v-model="newName" ref="focusMe">
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" width="8rem" height="2rem"
						 		@click="newLabelDialog = false">{{t('cancel')}}</v-btn>
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" width="8rem" height="2rem"
							 	@click="create" :loading="loading">{{t('make')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';

export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		newLabelDialog: false,
		newName: '',
		loading: false,
	}),
	watch: {
		dialogVisible: function(isVisible) {
			this.newLabelDialog = isVisible;
		},
		newLabelDialog: function(item) {
			this.$emit('visible', item);
			this.newName = '';
			if(item) {
				setTimeout(() => {
					this.$nextTick(() => this.$refs.focusMe.focus())
				}, 200);
			}
		},
	},
  mounted() {
    
  },
  methods: {
		groupNameCheckDuplicate() {
			let savedStoreGroupLabel = this.$store.getters.getStoreGroupLabel;
			if(savedStoreGroupLabel.length > 0) {
				let duplicateCheck = savedStoreGroupLabel.some((element) => {
					return element.labelName === this.newName
				});
				if(duplicateCheck == false) {
					return false;
				} else { // duplicateCheck가 true일때는 labelName 중복
					return true;
				}
			} else {
				return false;
			}
		},
		create() {
			if(this.newName === '') {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			if(this.groupNameCheckDuplicate()) {
				this.showToastMessage('既に存在するグループラベル名です。');
				return;
			}
			this.loading = true;
			// let labelArray = this.$store.getters.getStoreGroupLabel;
			let params = {
        labelName: this.newName
      };
      this.networkController.createNewStoreGroupLabel(params)
      .then((res) => {
				console.log(res.data);

				this.networkController.getStoreGroupLabel(params).then(async (response) => {
					console.log('%cFetch Store Group Label\n', "color:#008DD0;", response.data);
					await this.$store.commit('setStoreGroupLabel', response.data);

					this.loading = false;
					this.newLabelDialog = false;
					this.showToastMessage(this.tmb('requestSuccess'));
				}).catch(error => { });

				// labelArray.push({
				// 	...res.data,
				// 	storeGroups: []
				// });
			}).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
				this.loading = false;
			});
		}
  }
}
</script>

<style lang="scss" scoped>
.change_name_input {
  width: 100%;
  padding-left: 1em;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2.5em;
}
</style>